import { createEffect } from '@databases/selections';
import type {
  ResolvedSelection,
  SelectionsApiContract
} from '@databases/selections-api-types';
import { type DatabaseLayoutType } from '@databases/types/database/view';

const computeResolvedSelection = (
  resolvedSelection: ResolvedSelection,
  currentViewType: DatabaseLayoutType | undefined
): string[] => {
  if (!currentViewType) {
    return [];
  }

  const entryPrefix = currentViewType === 'table' ? 'entry' : 'card';
  switch (resolvedSelection.mode) {
    case 'row':
      return resolvedSelection.entries.map((entry) => `${entryPrefix}:${entry.entryId}`);
    case 'column':
      return resolvedSelection.fields.map((field) => `field:${field.fieldId}`);
    case 'cell':
      return resolvedSelection.values.map(
        (value) => `cell:${value.entryId}:${value.fieldId}`
      );
    case 'idle':
      return [];
  }
};

export interface PublishRovoEffectDeps {
  selectionsApi: SelectionsApiContract;
  publishSelectionToRovo: (selection: string[]) => void;
  currentViewType: DatabaseLayoutType | undefined;
}

export const createPublishRovoSelectionEffect = createEffect(
  ({ selectionsApi, publishSelectionToRovo, currentViewType }: PublishRovoEffectDeps) => {
    return {
      deltaTypes: ['selectionReplaced', 'selectionModified', 'focusChanged'],

      dispose() {
        publishSelectionToRovo([]);
      },

      onDelta(_delta, _state) {
        const resolvedSelection = selectionsApi.getResolvedSelection();
        const activeSelection = computeResolvedSelection(
          resolvedSelection,
          currentViewType
        );

        publishSelectionToRovo(activeSelection);
      }
    };
  }
);
